import React from 'react'
import { $TOWNS } from '@components/$TOWNS/$TOWNS'
import { InteractiveSpaceIcon } from '@components/SpaceIcon'
import { TownYield } from '@components/Web3/Wallet/StakedTokensTab'
import { Box, Paragraph, Stack } from '@ui'
import { useFetchOperatorsQuery } from 'hooks/useOperatorData'
import { atoms } from 'ui/styles/atoms.css'
import { SpaceItem, useSpaceDelegationOperator } from 'use-towns-client'

export const StakeSpaceCard = ({
    spaceAddress,
    spaces,
    amount,
}: {
    spaceAddress: `0x${string}`
    spaces: SpaceItem[]
    amount?: bigint
}) => {
    const space = spaces.find((o) => o.address.toLowerCase() === spaceAddress?.toLowerCase())

    const { data: currentDelegation } = useSpaceDelegationOperator(spaceAddress)

    const { data: operators } = useFetchOperatorsQuery()

    const operator = operators?.operators.find(
        (o) => o.address.toLowerCase() === currentDelegation?.toLowerCase(),
    )

    if (!space) {
        return null
    }

    return (
        <Stack horizontal padding gap background="level2" rounded="md" data-testid="space-card">
            <Box inset="xs">
                <InteractiveSpaceIcon
                    size="xs"
                    spaceId={space.streamId}
                    address={space.address}
                    spaceName={space.name}
                />
            </Box>
            <Box justifyContent="center">
                <Box gap="paragraph">
                    <Paragraph fontWeight="strong" color="default" size="lg">
                        {space.name}
                    </Paragraph>

                    <TownYield
                        spaceAddress={spaceAddress}
                        renderer={(children) => (
                            <Paragraph color="gray2">
                                Estimated Yield:{' '}
                                <span className={atoms({ color: 'cta1', fontWeight: 'strong' })}>
                                    {children}
                                </span>
                            </Paragraph>
                        )}
                    />

                    {operator ? (
                        <Stack horizontal gap="sm" alignItems="center">
                            <Box>
                                <Paragraph color="gray2">
                                    Delegated to{' '}
                                    <span
                                        className={atoms({
                                            color: 'default',
                                            fontWeight: 'strong',
                                        })}
                                    >
                                        {operator.name}
                                    </span>
                                </Paragraph>
                            </Box>
                        </Stack>
                    ) : (
                        <Stack gap="sm">
                            <Paragraph color="gray2">No operator delegated</Paragraph>
                        </Stack>
                    )}
                    {amount && (
                        <Paragraph color="gray2">
                            Current Stake:{' '}
                            <span className={atoms({ color: 'default', fontWeight: 'strong' })}>
                                <$TOWNS value={amount} />
                            </span>
                        </Paragraph>
                    )}
                </Box>
            </Box>
        </Stack>
    )
}
